import styled, { css } from 'styled-components';
import { Box } from 'edenred-ui';

const fadeOutStyles = css`
  mask-image: linear-gradient(to right, black 80%, transparent 100%);
  -webkit-mask-image: linear-gradient(to right, black 80%, transparent 100%);
  cursor: default;
`;

export const StyledOverflowTooltipContent = styled<{ $addMask: boolean }>(Box)`
  white-space: nowrap;
  overflow: hidden;
  position: relative;
  width: 100%;
  max-width: 100%;
  ${({ $addMask }) => $addMask && fadeOutStyles}
`;
